import React, { Fragment, useContext, useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { LayoutContext } from "../index";
import { cartListProduct } from "./FetchApi";
import { isAuthenticate } from "../auth/fetchApi";
import { cartList } from "../productDetails/Mixins";
import { subTotal, quantity } from "./Mixins";

const apiURL = process.env.REACT_APP_API_URL;

const ItemCarrinho = ({ item, remover }) => {
  return (
    <div className="text-white flex space-x-2 my-4 items-center">
      <img
        className="w-16 h-16 object-cover rounded-lg"
        src={`${apiURL}/uploads/products/${item.pImages[0]}`}
        alt={item.pName}
      />
      <div className="relative w-full flex flex-col">
        <div className="my-2 font-semibold">{item.pName}</div>
        <div className="flex items-center justify-between text-sm text-gray-400">
          <div className="flex space-x-2">
            <span>Quantidade:</span>
            <span className="text-gray-200">{quantity(item._id)}</span>
          </div>
          <div>
            <span>Valor parcial: </span>
            <span className="text-white">
              {(subTotal(item._id, item.pPrice)).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              })}
            </span>
          </div>
        </div>
        <button
          onClick={() => remover(item._id)}
          className="absolute top-0 right-0 text-white hover:text-red-500"
        >
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

const ModalCarrinho = () => {
  const history = useHistory();
  const { data, dispatch } = useContext(LayoutContext);
  const produtos = data.cartProduct;
  const [selectedShipping, setSelectedShipping] = useState(null);

  const buscarProdutosCarrinho = useCallback(async () => {
    try {
      const resposta = await cartListProduct();
      if (resposta?.Products) {
        dispatch({ type: "cartProduct", payload: resposta.Products });
      }
    } catch (erro) {
      console.error("Erro ao buscar produtos do carrinho:", erro);
    }
  }, [dispatch]);

  useEffect(() => {
    buscarProdutosCarrinho();
    const savedShipping = localStorage.getItem("selectedShipping");
    if (savedShipping) {
      setSelectedShipping(JSON.parse(savedShipping));
    }
  }, [buscarProdutosCarrinho]);

  const alternarModalCarrinho = () => {
    dispatch({ type: "cartModalToggle", payload: !data.cartModal });
  };

  const removerProdutoCarrinho = (id) => {
    const carrinho = JSON.parse(localStorage.getItem("cart")) || [];
    const atualizado = carrinho.filter(item => item.id !== id);
    localStorage.setItem("cart", JSON.stringify(atualizado));

    if (atualizado.length === 0) {
      localStorage.removeItem("selectedShipping");
      setSelectedShipping(null);
      dispatch({ type: "cartProduct", payload: null });
    }

    dispatch({ type: "inCart", payload: cartList() });
    buscarProdutosCarrinho();
  };

  const finalizarCompra = () => {
    alternarModalCarrinho();
    if (isAuthenticate()) {
      history.push("/checkout");
    } else {
      dispatch({ type: "loginSignupError", payload: !data.loginSignupError });
      dispatch({ type: "loginSignupModalToggle", payload: !data.loginSignupModal });
      history.push("/");
    }
  };

  const calculateTotals = () => {
    const productsTotal = produtos?.reduce(
      (acc, item) => acc + (quantity(item._id) * item.pPrice),
      0
    ) || 0;

    const shippingCost = selectedShipping ? Number(selectedShipping.preco) : 0;
    return {
      productsTotal,
      shippingCost,
      total: productsTotal + shippingCost
    };
  };

  const { productsTotal, shippingCost, total } = calculateTotals();

  return (
    <Fragment>
      {data.cartModal && (
        <div className="fixed top-0 z-30 w-full h-full bg-black opacity-50" />
      )}

      <section className={`fixed z-40 inset-0 flex justify-end ${!data.cartModal && "hidden"}`}>
        <div className="w-full md:w-5/12 lg:w-4/12 h-full bg-gray-900 flex flex-col justify-between">
          {/* Header */}
          <div className="border-b border-gray-700 flex justify-between p-4 text-white text-lg font-semibold">
            <span>Carrinho</span>
            <button onClick={alternarModalCarrinho}>
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>

          {/* Product List */}
          <div className="overflow-y-auto p-4">
            {produtos?.length ? (
              produtos.map((item) => (
                <ItemCarrinho key={item._id} item={item} remover={removerProdutoCarrinho} />
              ))
            ) : (
              <div className="text-white text-center text-lg mt-4">
                Nenhum produto no carrinho
              </div>
            )}
          </div>

          {/* Price Breakdown */}
          <div className="p-4 space-y-4 border-t border-gray-700">
            <div className="space-y-3">
              <div className="flex justify-between text-gray-300">
                <span>Subtotal dos produtos</span>
                <span>
                  {productsTotal.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                  })}
                </span>
              </div>

              {selectedShipping && (
                <div className="flex justify-between text-gray-300">
                  <div className="flex flex-col">
                    <span>Frete • {selectedShipping.servico}</span>
                    <span className="text-xs text-gray-400">
                      {selectedShipping.transportadora} • {selectedShipping.prazo} dias úteis
                    </span>
                  </div>
                  <span>
                    {shippingCost.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL'
                    })}
                  </span>
                </div>
              )}

              <div className="flex justify-between text-white font-semibold pt-3 border-t border-gray-600">
                <span>Total</span>
                <span className="text-gold-500">
                  {total.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                  })}
                </span>
              </div>
            </div>

            {/* Action Buttons */}
            <button
              onClick={alternarModalCarrinho}
              className="w-full border border-gray-400 text-white py-3 rounded-lg hover:bg-gray-800 transition-colors"
            >
              Continuar comprando
            </button>
            <button
              onClick={finalizarCompra}
              className={`w-full py-3 rounded-lg text-white transition-colors ${
                total > 0 
                  ? "bg-gold-500 hover:bg-gold-600" 
                  : "bg-gray-700 cursor-not-allowed"
              }`}
              disabled={total <= 0}
            >
              {total > 0
                ? `Finalizar compra • ${total.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                  })}`
                : "Finalizar compra"}
            </button>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default ModalCarrinho;